import { createContext, useContext } from 'react';

export const AppShellContext = createContext(false);

export const useAppShell = () => useContext(AppShellContext);
